import { useEffect, useState } from "react";

const slides = [
  {
    image: "https://storage.readdy-site.link/project_files/66d27020-f786-4213-8dfe-a6abbcbec2f0/a3b820a2-4045-4115-b0a6-e7e8d8824abb_c473b76c-cedb-4f81-ab88-80e875b6d189.jpg?v=a01c4755574f4967bc03c8ffc8c0d3f5",
    label: "Balıkçı Zafer",
    overlay: "from-black/60 via-black/30 to-black/10",
  },
  {
    image: "https://public.readdy.ai/ai/img_res/76abc59dabb740cc42b88b5318846593.jpg",
    label: "Izgara Levrek",
    overlay: "from-black/75 via-black/45 to-black/20",
  },
  {
    image: "https://readdy.ai/api/search-image?query=fisherman%20pulling%20fishing%20nets%20from%20aegean%20sea%20at%20sunrise%2C%20traditional%20wooden%20fishing%20boat%2C%20izmir%20aliaga%20turkey%20coastline%2C%20golden%20morning%20light%20reflecting%20on%20calm%20water%2C%20authentic%20fishing%20lifestyle&width=1920&height=1080&seq=hero_slide2&orientation=landscape",
    label: "Sabah Avı",
    overlay: "from-black/75 via-black/45 to-black/20",
  },
  {
    image: "https://readdy.ai/api/search-image?query=cozy%20seafood%20restaurant%20interior%20with%20fishing%20nets%20on%20walls%2C%20wooden%20tables%20with%20white%20tablecloths%2C%20warm%20amber%20lighting%2C%20turkish%20coastal%20restaurant%20decor%2C%20inviting%20dining%20atmosphere%2C%20mediterranean%20style&width=1920&height=1080&seq=hero_slide3&orientation=landscape",
    label: "Restoranımız",
    overlay: "from-black/75 via-black/45 to-black/20",
  },
];

export default function HeroSection() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const duration = current === 0 ? 6000 : 4500;
    const timer = setTimeout(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, duration);
    return () => clearTimeout(timer);
  }, [current]);

  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="hero" className="relative w-full h-screen min-h-[640px] flex items-center overflow-hidden">
      {/* Slideshow Background */}
      {slides.map((slide, i) => (
        <div
          key={i}
          className={`absolute inset-0 transition-opacity duration-1200 ${i === current ? "opacity-100" : "opacity-0"}`}
        >
          <img
            src={slide.image}
            alt={slide.label}
            className="w-full h-full object-cover object-center"
          />
        </div>
      ))}

      {/* Dynamic Overlay */}
      <div className={`absolute inset-0 bg-gradient-to-r ${slides[current].overlay} transition-all duration-1000`}></div>
      <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>

      {/* Slide dots */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex gap-2 z-20">
        {slides.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrent(i)}
            className={`rounded-full transition-all duration-300 cursor-pointer ${i === current ? "w-6 h-2 bg-[#e8734a]" : "w-2 h-2 bg-white/40"}`}
          />
        ))}
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-12">
        <div className="max-w-2xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 border border-[#e8734a]/60 bg-[#e8734a]/10 backdrop-blur-sm text-white text-xs font-semibold px-4 py-2 rounded-full mb-6">
            <i className="ri-anchor-line text-[#e8734a]"></i>
            İzmir Aliağa &bull; Taze Balık Restoranı
          </div>

          {/* Heading */}
          <h1 className="text-5xl md:text-7xl font-bold text-white leading-[1.1] mb-5" style={{ fontFamily: "'Playfair Display', serif" }}>
            Denizin En<br />
            <span className="text-[#e8734a] italic">Taze</span> Lezzeti
          </h1>

          <p className="text-white/75 text-base md:text-lg mb-10 max-w-md leading-relaxed">
            Her sabah ağdan çıkan taze balıklar, Zafer ailesinin elleriyle hazırlanan geleneksel Ege tariflerinde buluşuyor.
          </p>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-3">
            <button
              onClick={() => handleScroll("#menu")}
              className="bg-[#e8734a] text-white px-8 py-4 rounded-full font-bold text-sm hover:bg-[#cf6340] transition-all duration-200 cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
            >
              <i className="ri-restaurant-2-line"></i>
              Menüyü Keşfet
            </button>
            <button
              onClick={() => handleScroll("#iletisim")}
              className="bg-white/10 backdrop-blur-sm text-white border border-white/30 px-8 py-4 rounded-full font-bold text-sm hover:bg-white/20 transition-all duration-200 cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
            >
              <i className="ri-phone-line"></i>
              Rezervasyon Yap
            </button>
          </div>

          {/* Stats row */}
          <div className="flex flex-wrap gap-4 mt-12">
            {[
              { icon: "ri-sun-line", value: "Her Sabah", label: "Taze Av" },
              { icon: "ri-store-2-line", value: "Aile", label: "İşletmesi" },
              { icon: "ri-award-line", value: "Geleneksel", label: "Ege Tarifleri" },
            ].map((s) => (
              <div key={s.label} className="flex items-center gap-3 bg-black/30 backdrop-blur-sm border border-white/15 rounded-2xl px-4 py-3">
                <div className="w-8 h-8 flex items-center justify-center bg-[#e8734a]/20 rounded-lg">
                  <i className={`${s.icon} text-[#e8734a] text-base`}></i>
                </div>
                <div>
                  <div className="text-white font-bold text-sm leading-none">{s.value}</div>
                  <div className="text-white/50 text-xs mt-0.5">{s.label}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Current slide label */}
      <div className="absolute bottom-8 right-8 z-20 hidden md:flex items-center gap-2 text-white/50 text-xs">
        <span className="w-6 h-px bg-white/30"></span>
        {slides[current].label}
      </div>

      {/* Luxury Info Strip */}
      <div className="absolute bottom-0 left-0 right-0 z-20 hidden md:block">
        <div className="max-w-7xl mx-auto px-12 pb-10">
          <div className="flex items-center gap-0 w-fit">
            {[
              { icon: "ri-phone-line", label: "Rezervasyon", value: "+90 (232) 000 00 00" },
              { icon: "ri-map-pin-2-line", label: "Adres", value: "Atatürk Cad. No:101/A, Aliağa" },
              { icon: "ri-time-line", label: "Çalışma", value: "Her Gün 11:00 – 22:00" },
            ].map((item, i) => (
              <div key={item.label} className="flex items-center">
                <div className="flex items-center gap-3 px-6 py-3 bg-white/8 backdrop-blur-md border border-white/15 first:rounded-l-full last:rounded-r-full">
                  <div className="w-7 h-7 flex items-center justify-center bg-[#e8734a]/20 rounded-full">
                    <i className={`${item.icon} text-[#e8734a] text-xs`}></i>
                  </div>
                  <div>
                    <div className="text-white/40 text-[10px] uppercase tracking-widest leading-none mb-0.5">{item.label}</div>
                    <div className="text-white text-xs font-medium tracking-wide whitespace-nowrap">{item.value}</div>
                  </div>
                </div>
                {i < 2 && <div className="w-px h-8 bg-white/15"></div>}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
